import React from "react";
import { useNavigate } from 'react-router-dom';

interface ServiceCardProps {
    title: string;
    description: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description }) => {

    const navigate = useNavigate();

    const handleNavigate = (path: string, id?: string) => {
        navigate(path);
        if (id) {
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <div className="flex text-left w-[300px] h-[210px] bg-[#ffffff9c] rounded-lg">
            <button onClick={() => window.open('https://wa.me/5512997143862?text=Olá, gostaria de entender melhor!', '_blank')} className="flex w-[100%] h-[100%]">
                <div className="flex flex-col w-[100%] h-[100%] p-3 items-start text-left ">
                    <h3 className="text-lg font-semibold mb-3 text-left">{title}</h3>
                    <p className=" text-left">{description}</p>
                </div>
            </button>
        </div>
    );
};


export default ServiceCard;